import classNames from 'classnames'

interface Props {
	id: string
	// width?: string
	title: string
	autoplay?: boolean
	rounded?: boolean
}

const Video = ({ id: youtubeId, title, autoplay, rounded = false }: Props) => {
	const baseSrc = `https://www.youtube-nocookie.com/embed/${youtubeId}?rel=0`
	const videoSrc = autoplay ? `${baseSrc}&autoplay=1&mute=1` : baseSrc

	return (
		<div className={classNames('video-wrapper', { 'video-rounded': rounded })}>
			<iframe
				width="100%"
				height="100%"
				src={videoSrc}
				frameBorder="0"
				allowFullScreen={true}
				title={title}
				className={classNames({ 'video-rounded': rounded })}
			/>
		</div>
	)
}

export default Video
